import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import GrowthOSCaseStudy from "./pages/GrowthOSCaseStudy";
import Onboard from "./pages/Onboard";
import OnboardShared from "./pages/OnboardShared";
import AdminOnboarding from "./pages/AdminOnboarding";

// Reset scroll on route change (unless navigating to an in-page anchor).
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/growthos" element={<GrowthOSCaseStudy />} />
        <Route path="/growthos.html" element={<Navigate to="/growthos" replace />} />
        <Route path="/onboard" element={<Onboard />} />
        <Route path="/onboard/shared/:token" element={<OnboardShared />} />
        <Route path="/admin/onboarding" element={<AdminOnboarding />} />
        {/* Legacy routes redirect home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
